import { theme } from '../../../themes/theme'
import type { TermRef } from '../types'

/**
 * Categorical data-visualisation palette for the player motivations, keyed by
 * motivation `code`. Not brand colours: each motivation needs a distinct,
 * stable hue across every chart, legend and dot in the feature.
 */
const MOTIVATION_COLOR_BY_CODE: Record<string, string> = {
  excitement_thrill: '#7c3aed',
  thinking_solving: '#3b82f6',
  collecting_treasure: '#f59e0b',
  discovering_worlds: '#06b6d4',
  customization_decoration: '#14b8a6',
  roleplaying_emotions: '#8b5cf6',
  resource_optimization: '#6366f1',
  strategic_planning: '#0ea5e9',
  completing_milestones: '#10b981',
  improving_skills: '#84cc16',
  competing_others: '#ef4444',
  working_others: '#ec4899',
}

/**
 * Neutral colour for a motivation outside the palette. Must stay a 6-digit
 * hex: consumers concatenate an alpha suffix (e.g. `${color}1a`) for tinted
 * backgrounds, which only works on full-length hex strings.
 */
export const MOTIVATION_FALLBACK_COLOR = theme.palette.grey[500]

/** Colour for a motivation reference or a motivation `code`. */
export const motivationColor = (motivation: TermRef | string): string =>
  MOTIVATION_COLOR_BY_CODE[typeof motivation === 'string' ? motivation : motivation.code] ?? MOTIVATION_FALLBACK_COLOR
